import React, { Component } from 'react';
import { StyleSheet, View, Text, Image, TouchableOpacity } from 'react-native';
import images from "../../images/ImagesControl";
import { Table } from '../../components/Table';
import { Row, Rows } from '../../components/Rows';

class Content1 extends Component {
    render() {
        return (
            <View>
                <Text style={styles.heading}>
                    {
                        "Editing(Read/Update/Delete) Module Data with SqlEntity"
                    }
                </Text>
                <Text style={styles.text}>
                    {
                        "In any modern transaction system, modifying data is always unavoidable. " +
                        "It is essential to enhance user experience by providing a flexible editing environment."
                    }
                </Text>
                <Text style={styles.subheading}>
                    {
                        "Aim:"
                    }
                </Text>
                <Text style={[styles.text, { paddingLeft: 20 }]}>
                    {
                        "1.	Read module records through SqlEntity"
                    }
                </Text>
                <Text style={[styles.text, { paddingLeft: 20 }]}>
                    {
                        "2.	Update module records through SqlEntity"
                    }
                </Text>
                <Text style={[styles.text, { paddingLeft: 20 }]}>
                    {
                        "3.	Delete module records through SqlEntity"
                    }
                </Text>
                <Text style={styles.subheading}>
                    {
                        "Scenario:"
                    }
                </Text>
                <Text style={styles.text}>
                    {
                        "Chris has done well with his ABC Fruit Company Online Shop. He wants to improve user experience when customers need to change their order. " +
                        "Customers have to call Chris and request for an order cancellation so that they can correct order content. " +
                        "Chris would like to implement editing feature in the online shop."
                    }
                </Text>
                <Text style={[styles.text, { paddingBottom: 20 }]}>
                    {
                        "Chris designs the layout as below."
                    }
                </Text>
            </View>
        );
    }
}

class Content2 extends Component {
    constructor(props) {
        super(props);

        this.state = {
            heightArr: [40, 40, 40, 40, 40, 40, 40],
            widthArr: [100, 150, 430],
            tableHead: ["Name", "Type", "Description"],
            tableData: [
                ["authorization", "String(Header)", "Required. Access Token obtained via OAuth"],
                ["client_id", "String(Header)", "Required. Client ID in M18 [OAuth Applications]"],
                ["module", "String(Path)", "Required. Module name, such as 'employee', can be found in data."],
                ["menuCode", "String(Query)", "Required. Menu code, such as 'employee', can be found in data dictionary."],
                ["id", "long(Query)", "Required. ID of the entity."],
                ["param", "json String(Query)", "Additional parameters for special actions."],
                ["iRev", "String(Query)", "If you want to read the old version of the entity, please set this value. " +
                    "If you want to read a delete entity, please set the id and iRev of the delete entity."],
            ],
        }
    }

    render() {
        const state = this.state;

        return (
            <View>
                <Text style={styles.text}>
                    {
                        "With past experience, Chris is able to list the saved order using "
                    }
                    <TouchableOpacity onPress={() => this.props.onPress(3)}>
                        <View>
                            <Text style={styles.hyperlink}>
                                {
                                    "stSearch"
                                }
                            </Text>
                        </View>
                    </TouchableOpacity>
                </Text>
                <Text style={styles.text}>
                    {
                        "We need to obtain the <entity> to view the order content."
                    }
                </Text>
                <Text style={[styles.text, { fontWeight: 'bold' }]}>
                    {
                        "HTTP Request"
                    }
                </Text>
                <Text style={[styles.text, { color: 'red' }]}>
                    {
                        "GET http://[server]/jsf/rfws/entity/read/[module]?menuCode=[menuCode]&id=[id]"
                    }
                </Text>
                <Text style={[styles.text, { fontWeight: 'bold' }]}>
                    {
                        "Parameters"
                    }
                </Text>
                <Table borderstyle={{ borderWidth: 1 }} style={styles.text}>
                    <Row data={state.tableHead} style={styles.tableCell}
                        widthArr={state.widthArr} textStyle={[styles.tableText, { fontWeight: 'bold' }]} />
                    <Rows data={state.tableData} style={styles.tableCell}
                        widthArr={state.widthArr} textStyle={styles.tableText} heightArr={state.heightArr} />
                </Table>
                <Text style={[styles.text, { paddingBottom: 20 }]}>
                    {
                        "<module>, <menuCode> and <id> are the necessary parameters for obtaining saved <entity>."
                    }
                </Text>
                <Image source={images.ch5_fig1} style={{ width: 885, height: 160 }} />
                <Text style={styles.text}>
                    {
                        "<id> needs our knowledge from "
                    }
                    <TouchableOpacity onPress={() => this.props.onPress(3)}>
                        <View>
                            <Text style={styles.hyperlink}>
                                {
                                    "Get ID by Code"
                                }
                            </Text>
                        </View>
                    </TouchableOpacity>
                </Text>
                <Text style={styles.text}>
                    {
                        "That is http://[server]/jsf/rfws/entity/getIdByCode/oldso?menuCode=oldso&code=ABCSO001"
                    }
                </Text>
                <Text style={[styles.text, { paddingBottom: 20 }]}>
                    {
                        "We are ready to get <entity> value."
                    }
                </Text>
            </View>
        );
    }
}

class Content3 extends Component {
    render() {
        return (
            <View>
                <Text style={styles.text}>
                    {
                        "Reading existing orders is the not the end. We need to update orders when customers changed content."
                    }
                </Text>
                <Text style={styles.text}>
                    {
                        "We have to make use of "
                    }
                    <TouchableOpacity onPress={() => this.props.onPress(4)}>
                        <View>
                            <Text style={styles.hyperlink}>
                                {
                                    "Save Entity"
                                }
                            </Text>
                        </View>
                    </TouchableOpacity>
                    {
                        ". Try this out by pressing [Submit] in above example."
                    }
                </Text>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    heading: {
        paddingTop: 20,
        fontSize: 30,
        fontWeight: 'bold',
    },
    subheading: {
        paddingTop: 20,
        fontSize: 20,
        fontWeight: 'bold',
    },
    text: {
        paddingTop: 20,
    },
    hyperlink: {
        fontStyle: 'iTalic',
        color: 'blue',
        textDecorationLine: 'underline',
    },
    tableText: {
        margin: 6,
        fontSize: 10
    },
    tableCell: {

    }
});

export { Content1, Content2, Content3 };



// WEBPACK FOOTER //
// ./src/pages/ch5/Content.js